import { render } from "./sti-detail-reverse-scan.vue?vue&type=template&id=be9572a2&scoped=true&ts=true"
import script from "./sti-detail-reverse-scan.vue?vue&type=script&lang=ts"
export * from "./sti-detail-reverse-scan.vue?vue&type=script&lang=ts"

import "./sti-detail-reverse-scan.vue?vue&type=style&index=0&id=be9572a2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be9572a2"]])

export default __exports__